<template>
  <my-modal>
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header text-center">
          <h3 class="text-center">
            Editar
            <b>{{detalle.articulo.descripcion}}</b>
          </h3>
          <button type="button" class="close" @click="cerrarModal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div
          class="modal-body justify-content-center"
          style="max-height:100%!important;height:auto!important;overflow:visible;"
        >
          <div class="row w-100">
            <float-label label="Importe $:" clase="col-md-4 col-12" v-if="user.tipo == 'Administrador'">
              <input
                v-model="detalle.importe"
                id="importe"
                placeholder="0.00"
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.detalle.importe.required || !$v.detalle.importe.decimal)) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.detalle.importe.required"
                >Debe ingresar el importe</div>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.detalle.importe.decimal"
                >Solo se aceptan números</div>
              </template>
            </float-label>
            <float-label label="Descuento %:" clase="col-md-4 col-12">
              <input
                v-model="detalle.descuento"
                id="descuento"
                placeholder="0.00"
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.detalle.descuento.required || !$v.detalle.descuento.decimal)) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.detalle.descuento.required"
                >Debe ingresar el descuento</div>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.detalle.descuento.decimal"
                >Solo se aceptan números</div>
              </template>
            </float-label>
            <FloatLabel label="Cantidad" clase=" col-md-4 col-12">
              <input
                v-model="detalle.cantidad"
                id="cantidad"
                placeholder="0.00"
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.detalle.cantidad.required || !$v.detalle.cantidad.decimal)) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.detalle.cantidad.required"
                >Debe ingresar la cantidad</div>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.detalle.cantidad.decimal"
                >Solo se aceptan números</div>
              </template>
            </FloatLabel>
          </div>
        </div>
        <div class="modal-footer justify-content-center">
          <div class="row w-100">
            <div class="col-md-4">
              <button class="btn btn-danger btn-block mb-2" @click="cerrarModal">Cerrar</button>
            </div>
            <div class="col-md-4 offset-md-4">
              <button class="btn btn-info btn-block mb-2" @click="confirmDetalle">Confirmar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </my-modal>
</template>
<script>
import { required, decimal } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import FloatLabel from "@/components/layouts/FloatLabel";
import MyModal from "@/components/layouts/MyModal";
import { mapGetters } from "vuex";
export default {
  name: "EditarDetalle",
  components: {
    FloatLabel,
    MyModal
  },
  data() {
    return {
      enviado: false
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    })
  },
  validations: {
    detalle: {
      importe: { required, decimal },
      descuento: { required, decimal },
      cantidad: { required, decimal }
    }
  },
  mounted() {
    document.getElementById("importe").focus();
  },
  props: ["detalle"],
  methods: {
    confirmDetalle() {
      this.detalle.importe = parseFloat(this.detalle.importe);
      this.detalle.cantidad = parseFloat(this.detalle.cantidad);
      this.detalle.descuento = parseFloat(this.detalle.descuento);
      this.detalle.editado = true;
      this.$v.$touch();
      this.enviado = true;
      if (this.$v.$invalid) {
        return false;
      }
      if (this.detalle.articulo.stock < this.detalle.cantidad) {
        Swal.fire({
          icon: "error",
          title: "Oopss..",
          text: `Stock insuficiente, quedan ${this.detalle.articulo.stock} unidades.`
        });
        return false;
      }
      this.$emit("confirmDetalle", this.detalle);
    },
    cerrarModal() {
      this.$emit("cerrarEditarDetalle");
    }
  }
};
</script>
